import React from 'react';

interface Props {
  empresas: { id: number; nome: string }[];
  /** Orientação exibida abaixo do título (o que está errado e como regularizar). */
  orientacao: string;
}

/**
 * Aviso de empresas órfãs: o total fica no título e cada empresa aparece em uma linha própria da lista
 * (em ordem alfabética), sem concatenar os nomes no texto. Com muitas empresas a lista rola dentro do
 * próprio aviso, e todos os nomes continuam legíveis, sem corte.
 */
const AvisoEmpresasOrfas: React.FC<Props> = ({ empresas, orientacao }) => {
  if (empresas.length === 0) return null;

  const ordenadas = [...empresas].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }));

  return (
    <div className='wf-alert-banner' role='alert'>
      <strong>Empresas órfãs detectadas ({empresas.length})</strong>
      <p className='wf-orfas-orientacao'>{orientacao}</p>
      <ul className='wf-orfas-lista' aria-label='Empresas órfãs'>
        {ordenadas.map(e => <li key={e.id}>{e.nome}</li>)}
      </ul>
    </div>
  );
};

export default AvisoEmpresasOrfas;
